import { apiFetch } from "../../utils/api";

export const sucursalesSlice = (set,get) => ({
    sucursales: [],
    handleSucursal: (e) => {
        console.log(e);
        set({ datos: { ...get().datos, sucursales: [e] } })
    },
    obtenerSucursales: async() => {
        try {
            const data = await apiFetch("/api/branches");
            if(data.status){
                const sucursales = data.data.map((item) => { return { value: item.id, label: item.nombre } });
                set({ sucursales })
                if (!get().datos?.sucursales && sucursales.length === 1) {
                    set({ datos: { ...get().datos, sucursales: sucursales[0] } })
                }
            } else {
                set({ sucursales: [] })
            }
        } catch (error) {
            console.error('Error:', error);
            set({ sucursales: [] })
        }
    }
})
